<script setup lang="ts">
import type { Question } from '../calendarQuestion'
import CalendarQuestionsNavigationEditSelectBox from './CalendarQuestionsNavigationEditSelectBox.vue'
import CalendarQuestionsNavigationEditText from './CalendarQuestionsNavigationEditText.vue'

const model = defineModel<Question>()
</script>

<template>
  <template v-if="model">
    <CalendarQuestionsNavigationEditText
      v-if="model.type === 'TEXT'"
      v-model="model"
    />
    <CalendarQuestionsNavigationEditSelectBox
      v-else-if="model.type === 'SELECT_BOX'"
      v-model="model"
    />
  </template>
</template>

<style lang="scss" module>
.navigation {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
</style>
